import { useEffect, useState } from 'react'

import { api, ApiError } from '../api'
import type { SystemsResponse } from '../../contracts/api'

/**
 * Расчёт карт один на все комнаты: список и каждая комната читают один и тот
 * же ответ /api/systems. Держим его в модуле — иначе «список → комната →
 * назад» перезапрашивает карту на каждый шаг, а она натальная и не меняется.
 */
let cache: SystemsResponse | null = null

export function useCharts(): { data: SystemsResponse | null; error: string } {
  const [data, setData] = useState<SystemsResponse | null>(cache)
  const [error, setError] = useState('')

  useEffect(() => {
    if (cache) return undefined
    let cancelled = false
    api
      .get<SystemsResponse>('/api/systems')
      .then((result) => {
        cache = result
        if (!cancelled) setData(result)
      })
      .catch((cause: unknown) => {
        if (!cancelled) setError(cause instanceof ApiError ? cause.message : 'Карты пока не открылись')
      })
    return () => {
      cancelled = true
    }
  }, [])

  return { data, error }
}
